import { FlaskConical, UserCheck, FileText, Target } from "lucide-react";
import type { Differentiator } from "@/data";

const iconMap = {
  beaker: FlaskConical,
  physician: UserCheck,
  document: FileText,
  target: Target,
} as const;

// 56×56 leaf-green circle with white line icon (frame 23:24..23:39).
export function DifferentiatorCard({ item }: { item: Differentiator }) {
  const Icon = iconMap[item.icon];
  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-leaf-green-ink text-white">
        <Icon size={26} strokeWidth={1.75} />
      </div>
      <h3 className="font-condensed text-base font-bold uppercase tracking-wide text-night-blue">
        {item.title}
      </h3>
      <p className="max-w-[26ch] text-sm text-night-blue/70">{item.body}</p>
    </div>
  );
}
